import { ClosePrimaryIcon } from "@ubnt/icons";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

export const GptTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.text1};
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 24px;
    line-height: 32px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const StyledLogoImg = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const StyledSendButton = styled.span`
  background: transparent;
  outline: none;
  border: none;
  display: flex;
  position: absolute;
  right: 18px;
  top: 10px;

  svg {
    transition: color 0.3s ease-in-out;
  }
`;

export const Background = styled.div`
  background: ${({ theme }) => theme.colors.neutral00};
`;

export const Container = styled.div<{ $isExpanded?: boolean }>`
  background: ${({ theme }) => theme.colors.neutral00};
  border-radius: 8px;
  transition: height 0.3s ease-out;

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      height: 564px;
    `}
`;

export const StyledCloseIcon = styled(ClosePrimaryIcon)`
  color: ${({ theme }) => theme.colors.neutral08};
`;

export const RelativeContainer = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  opacity: 0;
  left: -9999px;
  transition: opacity 0.3s ease-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      position: relative;
      opacity: 1;
      left: 0;
    `}
`;

export const TransparentButton = styled.button`
  background: transparent;
  position: absolute;
  top: 16px;
  right: 16px;
  outline: none;
  box-shadow: none;
  border: none;
`;

export const InputBlockWrapper = styled.div<{ $isVisible?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: 0;
  position: absolute;
  left: -9999px;
  transition: opacity 0.3s ease-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      position: relative;
      left: 0;
    `}

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    flex-direction: column;
    gap: 8px;
  }
`;

export const StyledInputPlaceholder = styled.span`
  width: 100%;
  height: 100%;
  border-radius: 58px;
  direction: ltr;
  padding: 10px 20px;
  font-size: 14px;
  border: none;
  display: flex;
  align-items: center;
  outline: none;
  background-color: ${({ theme }) => theme.colors.neutral02};
  text-align: left;
  color: ${({ theme }) => theme.colors.text3};
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
`;

export const StyledEmbed = styled.embed`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral02};
  height: 562px;
  width: 100%;
`;

export const InputButton = styled.button`
  position: relative;
  height: 40px;
  width: 100%;
  background: transparent;
  outline: none;
  border: none;

  &:hover {
    ${StyledInputPlaceholder} {
      border: 1px solid ${({ theme }) => theme.colors.ublue06};
    }

    ${StyledSendButton} svg {
      color: ${({ theme }) => theme.colors.ublue06};
    }
  }
`;
